import { Button, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export const StyledLinkTypography = styled(Typography)`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
  color: ${(props) => props.theme.palette.text.primary};
  text-decoration: none;
  text-transform: none;
  align-item: center;
  padding: 0;
  line-height: 220%;

  &:hover {
    color: ${(props) => props.theme.palette.primary.main};
    cursor: pointer;
    text-decoration: underline;
    background-color: transparent;
  }
`

export const StyledHeaderLinkTypography = styled(Typography)`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
  font-weight: 500;
  color: ${(props) => props.theme.palette.text.primary};
  text-decoration: none;
  align-item: center;
  padding: 0;
  line-height: 220%;

  &:hover {
    color: ${(props) => props.theme.palette.primary.main};
    cursor: pointer;
    text-decoration: underline;
    background-color: transparent;
  }
`

export const StyledLinkButton = styled(Button)`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
  font-weight: 500;
  color: ${(props) => props.theme.palette.text.primary};
  text-decoration: none !important;
  align-item: center;
  padding: 0;

  &:hover {
    color: ${(props) => props.theme.palette.primary.main};
    cursor: pointer;
    text-decoration: underline;
    background-color: transparent;
  }
`
